const getEuData = (locale = 'eu') => {
    const item1 = {
        eu: '10539681415511',
        uk: '10418180129107',
        de: '15793811784061',
        fr: '10330992214363',
        it: '15004745957752',
        es: '10330994540891',
    }[locale];
    const item2 = {
        eu: '10559341298007',
        uk: '10399201198419',
        de: '15794386895229',
        fr: '10330992247131',
        it: '15004745990520',
        es: '10330994573659',
    }[locale];
    const item3 = {
        eu: '10524713222487',
        uk: '10418180096339',
        de: '15793811751293',
        fr: '10353987879259',
        it: '15009859961208',
        es: '10353989583195',
    }[locale];
    const item4 = {
        eu: '10553790562647',
        uk: '10418180161875',
        de: '15793811816829',
        fr: '10353960157531',
        it: '15009846198648',
        es: '10353968578907',
    }[locale];
    const productId1 = {
        eu: '10057130049879',
        uk: '9922548629843',
        de: '15246676164989',
        fr: '9916300656987',
        it: '14929760649592',
        es: '9916312224091',
        nl: '9935713861908',
    }[locale];
    const productId2 = {
        eu: '10057130639703',
        uk: '9922552103251',
        de: '15246676590973',
        fr: '9916300820827',
        it: '14929760682360',
        es: '9916312355163',
        nl: '9935713927444',
    }[locale];
    const productId3 = {
        eu: '9604647747927',
        uk: '9430789095763',
        de: '9535539315023',
        fr: '9432019370331',
        it: '9760871121245',
        es: '9432041029979',
        nl: '9935709962516',
    }[locale];
    return [
        {
            children: [
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1762932287156/1_white.png',
                    productId: item1,
                    variantId: (() => {
                        const id = {
                            eu: '52711547076951',
                            uk: '52981459222867',
                            de: '57799311360381',
                            fr: '52259122217307',
                            it: '55448455283064',
                            es: '52259129393499',
                        };
                        return id[locale as 'eu'] || id.eu;
                    })(),
                    color: '#e2e2df',
                    name: 'white',
                },
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1762932286102/1_black.png',
                    productId: item1,
                    variantId: (() => {
                        const id = {
                            eu: '52711547109719',
                            uk: '52981459255635',
                            de: '57799311393149',
                            fr: '52259122250075',
                            it: '55448455315832',
                            es: '52259129426267',
                        };
                        return id[locale as 'eu'] || id.eu;
                    })(),
                    color: '#212121',
                    name: 'black',
                },
            ],
            type: 'power-bank',
            new: true,
        },
        {
            children: [
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1762932286251/2_white.png',
                    productId: item2,
                    variantId: (() => {
                        const id = {
                            eu: '52761883574615',
                            uk: '52908619399507',
                            de: '57801383772541',
                            fr: '52259122282843',
                            it: '55141750374776',
                            es: '52259129524571',
                        };
                        return id[locale as 'eu'] || id.eu;
                    })(),
                    color: '#e2e2df',
                    name: 'white',
                },
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1762932286420/2_black.png',
                    productId: item2,
                    variantId: (() => {
                        const id = {
                            eu: '52761883607383',
                            uk: '52908619432275',
                            de: '57801383805309',
                            fr: '52259122315611',
                            it: '55448455381368',
                            es: '52259129557339',
                        };
                        return id[locale as 'eu'] || id.eu;
                    })(),
                    color: '#212121',
                    name: 'black',
                },
            ],
            type: 'power-bank',
            new: true,
        },

        {
            children: [
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1748415463061/black.png',
                    productId: productId1,
                    variantId: (() => {
                        const id = {
                            eu: '50740963475799',
                            uk: '51053411107155',
                            de: '56082576441725',
                            fr: '50630586204507',
                            it: '55141750342008',
                            es: '50630616285531',
                            nl: '51194426261780',
                        };
                        return id[locale as 'eu'] || id.eu;
                    })(),
                    color: '#212121',
                    name: 'black',
                },
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1748415464726/white.png',
                    productId: productId1,
                    variantId: (() => {
                        const id = {
                            eu: '50740963508567',
                            uk: '51053411139923',
                            de: '56082576474493',
                            fr: '50630586237275',
                            it: '55141750374776',
                            es: '50630616318299',
                            nl: '51194426229012',
                        };
                        return id[locale as 'eu'] || id.eu;
                    })(),
                    color: '#e2e2df',
                    name: 'white',
                },
            ],
            type: 'power-bank',
            spec: true,
        },
        {
            children: [
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1748415463227/black2.png',
                    productId: productId2,
                    variantId: (() => {
                        const id = {
                            eu: '50740965605719',
                            uk: '51053411860819',
                            de: '56082582045053',
                            fr: '50630586663259',
                            it: '55141752439160',
                            es: '50630617629019',
                            nl: '51194426425620',
                        };
                        return id[locale as 'eu'] || id.eu;
                    })(),
                    color: '#212121',
                    name: 'black',
                },
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1748415464925/white2.png',
                    productId: productId2,
                    variantId: (() => {
                        const id = {
                            eu: '50740965638487',
                            uk: '51053411893587',
                            de: '56082582077821',
                            fr: '50630586696027',
                            it: '55141752471928',
                            es: '50630617661787',
                            nl: '51194426392852',
                        };
                        return id[locale as 'eu'] || id.eu;
                    })(),
                    color: '#e2e2df',
                    name: 'white',
                },
            ],
            type: 'power-bank',
            spec: true,
        },
        {
            children: [
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1749115573021/50-black.png',
                    color: '#212121',
                    productId: productId3,
                    variantId: (() => {
                        const id = {
                            eu: '49178411270487',
                            uk: '49700418093395',
                            de: '49966509588815',
                            fr: '48933508219227',
                            it: '54413549306205',
                            es: '49343927157083',
                            nl: '51194413580564',
                        };
                        return id[locale as 'eu'] || id.eu;
                    })(),
                    name: 'black',
                },
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1748679704700/1.png',
                    color: '#cdcdcd',
                    productId: productId3,
                    variantId: (() => {
                        const id = {
                            eu: '49178411303255',
                            uk: '49700418027859',
                            de: '49966509523279',
                            fr: '48933508251995',
                            it: '54413549240669',
                            es: '49343927091547',
                            nl: '51194413515028',
                        };
                        return id[locale as 'eu'] || id.eu;
                    })(),
                    name: 'silver',
                },
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1749115573309/50-blue.png',
                    color: '#c0defe',
                    productId: productId3,
                    variantId: (() => {
                        const id = {
                            eu: '49178411336023',
                            uk: '49700418060627',
                            de: '49966509556047',
                            fr: '48933508284763',
                            it: '54413549273437',
                            es: '49343927124315',
                            nl: '51194413547796',
                        };
                        return id[locale as 'eu'] || id.eu;
                    })(),
                    name: 'blue',
                },
            ],
            type: 'power-bank',
            spec: true,
        },
        {
            children: [
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1749115573544/100-black.png',
                    color: '#212121',
                    productId: productId3,
                    variantId: (() => {
                        const id = {
                            eu: '49178411368791',
                            uk: '49700418191699',
                            de: '49966509687119',
                            fr: '48933508317531',
                            it: '54413549404509',
                            es: '49343927255387',
                            nl: '51194413646100',
                        };
                        return id[locale as 'eu'] || id.eu;
                    })(),
                    name: 'black',
                },
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1748679704863/2.png',
                    color: '#cdcdcd',
                    productId: productId3,
                    variantId: (() => {
                        const id = {
                            eu: '49178411401559',
                            uk: '49700418126163',
                            de: '49966509621583',
                            fr: '48933508350299',
                            it: '54413549338973',
                            es: '49343927189851',
                            nl: '51194413613332',
                        };
                        return id[locale as 'eu'] || id.eu;
                    })(),
                    name: 'silver',
                },
            ],
            type: 'power-bank',
            spec: true,
        },

        {
            children: [
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1762932286686/3_white.png',
                    productId: item3,
                    variantId: (() => {
                        const id = {
                            eu: '52667841315159',
                            uk: '52981459157331',
                            de: '57799311294845',
                            fr: '52473963250011',
                            it: '55480040849784',
                            es: '52473972392283',
                        };
                        return id[locale as 'eu'] || id.eu;
                    })(),
                    color: '#e2e2df',
                    name: 'white',
                },
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1762932286890/3_black.png',
                    productId: item3,
                    variantId: (() => {
                        const id = {
                            eu: '52667841347927',
                            uk: '52981459190099',
                            de: '57799311327613',
                            fr: '52473963282779',
                            it: '55480040882552',
                            es: '52473972425051',
                        };
                        return id[locale as 'eu'] || id.eu;
                    })(),
                    color: '#212121',
                    name: 'black',
                },
            ],
            type: 'charger',
            new: true,
        },
        {
            children: [
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1772518624449/ecoflow-rapid-mag-qi2-wireless-charging-stand-3-in-1-1219717369.webp',
                    productId: item4,
                    variantId: (() => {
                        const id = {
                            eu: '52747357159767',
                            uk: '52981459288403',
                            de: '57799311425917',
                            fr: '52473896960347',
                            it: '55479965516152',
                            es: '52473924485467',
                        };
                        return id[locale as 'eu'] || id.eu;
                    })(),
                    color: '#e2e2df',
                    name: 'white',
                },
                {
                    pc: 'https://websiteoss.ecoflow.com/upload/image/1772518833383/ecoflow-rapid-mag-qi2-wireless-charging-stand-3-in-1-1219717367.webp',
                    productId: item4,
                    variantId: (() => {
                        const id = {
                            eu: '52747357192535',
                            uk: '52981459321171',
                            de: '57799311458685',
                            fr: '52473896993115',
                            it: '55479965548920',
                            es: '52473924518235',
                        };
                        return id[locale as 'eu'] || id.eu;
                    })(),
                    color: '#212121',
                    name: 'black',
                },
            ],
            type: 'charger',
            new: true,
        },
    ];
};

export default {
    eu: getEuData('eu'),
    uk: getEuData('uk'),
    de: getEuData('de'),
    fr: getEuData('fr'),
    it: getEuData('it'),
    es: getEuData('es'),
};
